<template>
  <div id="setmall" class="showCate">
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <div>
        <div
          class="br-pagetitle d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <i class="icon ion-aperture"></i>
            <div class="mg-l-20">
              <h4>{{ $t("product.添加新品信息") }}</h4>
            </div>
          </div>
        </div>
      </div>
      <template>
        <div class="card mg-x-50 pd-20 mg-t-10 card-subuser">
          <div class="form-group row mg-0 mg-b-15">
            <template
              v-for="item in styleTemplate"
              v-if="item.isShow && item.key == 'name'"
            >
              <label class="col-form-label form-control-sm text-right col-1">
                {{ item.name }}：<span v-if="item.isMust" class="tx-danger"
                  >*</span
                >
              </label>
              <div class="col-md-5 col-sm-12 d-flex tx-gray-900">
                <template v-if="item.type == 'txt'">
                  <template v-if="item.key == 'weight'">
                    <input
                      class="form-control form-control-sm tx-13"
                      v-model="item.templateValue"
                      type="text"
                      style="width: 50%"
                    />
                    <span class="mg-l-10">{{ $t("product.克") }}</span>
                  </template>
                  <template v-else>
                    <div class="row d-flex align-items-center col-10">
                      <input
                        class="form-control form-control-sm tx-13"
                        v-model.trim="item.templateValue"
                        type="text"
                      />
                      <!--<span v-if="item.templateValue" class=" tx-gray-700 tx-12">($t('product.已输入'){{item.templateValue.length}}$t('product.字'))</span>-->
                    </div>
                  </template>
                </template>
              </div>
              <label class="col-form-label form-control-sm text-right col-1">
                SKU{{ $t("product.：")
                }}<span v-if="item.isMust" class="tx-danger">*</span>
              </label>
              <div class="col-md-5 col-sm-12 d-flex tx-gray-900">
                <div class="row d-flex align-items-center col-10">
                  <input
                    :disabled="$route.query.id"
                    class="form-control form-control-sm tx-13"
                    v-model.trim="itemSku"
                    type="text"
                  />
                </div>
              </div>
            </template>
          </div>
          <div class="form-group row mg-0 mg-b-0">
            <template
              v-for="item in styleTemplate"
              v-if="
                item.key != 'propertyImage' &&
                item.key != 'saleRemark' &&
                item.key != 'purchaseRemark' &&
                item.key != 'productRemark' &&
                item.key != 'name' &&
                item.isShow
              "
            >
              <label
                class="col-form-label form-control-sm text-right col-1 mg-b-15"
              >
                {{ item.name }}{{ $t("product.：")
                }}<span v-if="item.isMust" class="tx-danger">*</span>
              </label>
              <div
                class="col-md-5 col-sm-12 d-flex tx-gray-900 mg-b-15"
                style="flex-wrap: wrap"
              >
                <template v-if="item.type == 'txt'">
                  <template v-if="item.key == 'weight'">
                    <input
                      class="form-control form-control-sm tx-13"
                      v-model="item.templateValue"
                      type="text"
                      style="width: 50%"
                    />
                    <span class="mg-l-10">克</span>
                  </template>
                  <template v-else>
                    <div class="row d-flex align-items-center w-100">
                      <div class="col-10">
                        <input
                          class="form-control form-control-sm tx-13"
                          v-model.trim="item.templateValue"
                          type="text"
                        />
                      </div>
                      <!--<span v-if="item.templateValue" class=" tx-gray-700 tx-12">($t('product.已输入'){{item.templateValue.length}}$t('product.字'))</span>-->
                    </div>
                  </template>
                </template>
                <template v-if="item.type == 'select'">
                  <select
                    class="form-control form-control-sm"
                    v-model="item.templateValue"
                    style="width: 50%"
                  >
                    <option value="">{{ $t("product.请选择") }}</option>
                    <option
                      v-for="select in item.valueArr"
                      :key="select.key"
                      :value="select.key"
                    >
                      {{ select.text }}
                    </option>
                  </select>
                </template>
                <template v-if="item.type == 'checkbox'">
                  <div
                    class="
                      d-flex
                      flex-column flex-wrap
                      align-items-center
                      mg-y-5
                    "
                    v-for="(ckbox, i) in item.valueArr"
                  >
                    <label
                      style="display: inline-block"
                      class="ckbox mg-b-0 mg-r-20"
                    >
                      <input
                        type="checkbox"
                        :value="ckbox.key"
                        :disabled="
                          item.valueChecked &&
                          item.valueChecked.length &&
                          item.valueChecked[i] == ckbox.key
                        "
                        v-model="item.templateValue"
                      />
                      <span class="">{{ ckbox.text }}</span>
                    </label>
                  </div>
                </template>
                <template v-if="item.type == 'radio'">
                  <div
                    class="
                      d-flex
                      flex-column flex-wrap
                      align-items-center
                      mg-y-5
                    "
                    v-for="(rdiobox, i) in item.valueArr"
                  >
                    <label
                      style="display: inline-block"
                      class="rdiobox mg-b-0 mg-r-20"
                    >
                      <input
                        type="radio"
                        :value="rdiobox.key"
                        v-model="item.templateValue"
                      />
                      <span class="pd-0">{{ rdiobox.text }}</span>
                    </label>
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="form-group row mg-0 mg-b-15">
            <template
              v-for="item in styleTemplate"
              v-if="item.isShow && item.key == 'propertyImage'"
            >
              <label class="col-form-label form-control-sm text-right col-1">
                {{ item.name }}{{ $t("product.：")
                }}<span v-if="item.isMust" class="tx-danger">*</span>
              </label>
              <div class="col-md-11 col-sm-12 d-flex tx-gray-900">
                <template v-if="item.type == 'img'">
                  <div class="wd-100p">
                    <span
                      v-if="item.rule && item.rule.isMust"
                      class="tx-gray-600"
                      >{{ item.rule.remark }}</span
                    >
                    <div class="d-flex align-items-center">
                      <div
                        class="pos-relative upload-img-wrap mg-r-0"
                        style="margin-top: 10px; height: auto"
                      >
                        <template>
                          <draggable
                            @update="datadragEnd"
                            v-model="item.imgvalue"
                            :options="{ animation: 300, handle: '.dargDiv' }"
                          >
                            <a
                              v-if="item.imgvalue.length"
                              v-for="img in item.imgvalue"
                              class="upload-img mg-r-15 pos-relative dargDiv"
                              style="
                                width: 100px;
                                height: 100px;
                                background-size: cover;
                              "
                              :class="{ isIll: $isIll(img) }"
                              href="javascript:;"
                              v-lazy:background-image="img"
                            >
                            </a>
                            <a
                              class="upload-img mg-r-15 pos-relative"
                              style="
                                width: 100px;
                                height: 100px;
                                background-size: cover;
                                background: #f6f6f6;
                              "
                              href="javascript:;"
                              @click="openModalUpload(item)"
                            >
                              <i
                                style="
                                  font-size: 34px;
                                  position: absolute;
                                  left: 50%;
                                  top: 40%;
                                  transform: translate(-50%, -50%);
                                  color: #999;
                                "
                                class="icon ion-android-add-circle"
                              ></i>
                              <span
                                class="
                                  pos-absolute
                                  tx-14 tx-gray-600
                                  b-10
                                  l-0
                                  tx-center
                                  wd-100p
                                "
                                >{{ $t("product.上传图片") }}</span
                              >
                            </a>
                          </draggable>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </div>
        <div class="card mg-x-50 pd-20 mg-t-10 card-subuser">
          <div
            class="form-group row mg-0 mg-b-15"
            v-for="item in styleTemplate"
            v-if="
              (item.key == 'saleRemark' ||
                item.key == 'purchaseRemark' ||
                item.key == 'productRemark') &&
              item.isShow
            "
          >
            <label class="col-form-label form-control-sm text-right col-1">
              {{ item.name }}{{ $t("product.：")
              }}<span v-if="item.isMust" class="tx-danger">*</span>
            </label>
            <div class="col-md-11 col-sm-12 d-flex tx-gray-900">
              <textarea
                rows="5"
                style="width: 100%"
                :placeholder="'请输入' + item.name"
                v-model="item.templateValue"
                class="form-control form-control-sm tx-13"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="card mg-x-50 pd-20 mg-t-10 card-subuser">
          <div class="form-group mg-b-0">
            <div class="modal-footer" style="border-top: none">
              <button
                type="button"
                class="
                  btn btn-info
                  tx-11 tx-uppercase
                  pd-y-12 pd-x-25
                  tx-mont tx-semibold
                "
                @click="savePro()"
              >
                保存商品信息
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
    <api-loading :show="loading"></api-loading>
    <ModalUploadProductImages
      :open="openUploadProductImages"
      :imgRule="uploadPImgData.imgRule"
      :sku="uploadPImgData.sku"
      :minSelected="uploadPImgData.min"
      :maxSelected="uploadPImgData.max"
      :loading="uploadPImgData.loading"
      :spuId="uploadPImgData.spuId"
      :spuImages="uploadPImgData.spuImages"
      :stocks="uploadPImgData.stocks"
      :type="1"
      :spu="uploadPImgData.spu"
      @save="uploadProductImgSave"
    />
  </div>
</template>

<script>
// 选商品图片
import ModalUploadProductImages from "@components/supplier/modal-upload-product-images";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      leftSideStatus: true, //$t('product.左边栏状态')
      loading: false,
      styleTemplate: [],
      openUploadProductImages: Symbol(),
      uploadPImgData: {
        loading: false,
        imgRule: null,
        sku: "",
        min: 1,
        max: "",
        spuId: "",
        spuImages: [],
        stocks: [],
        spu: this.$route.query.sku ? this.$route.query.sku : "",
      },
      uploadPImgDataDefault: "{}",
      itemSku: "",
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    this.uploadPImgDataDefault = JSON.stringify(this.uploadPImgData);
  },
  updated() {
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
  components: {
    ModalUploadProductImages,
    draggable,
  },
  computed: {},
  watch: {},
  methods: {
    uploadProductImgSave(type, selectedItem) {
      if (type == "majorImageUrl") {
        //			this.items.styleTemplate[0].imgValue = selectedItem;
        //$t('product.替换')spu$t('product.图片')
        this.styleTemplate.forEach((e) => {
          if (e.key == "propertyImage") {
            this.$set(e, "imgvalue", selectedItem);
          }
        });
      }
      $("#modalUploadProductImages").modal("hide");
    },
    openModalUpload(item, max = 100, min = 8) {
      this.uploadPImgData = JSON.parse(this.uploadPImgDataDefault);
      this.uploadPImgData.imgRule = item.rule;
      if (item.rule && item.rule.isMust) {
        //$t('product.图片')上传有限制
        this.uploadPImgData.max = item.rule.quantityRule.split("||").pop();
        this.uploadPImgData.min = item.rule.quantityRule.split("||").shift();
      } else {
        this.uploadPImgData.max = max;
        this.uploadPImgData.min = min;
      }
      this.uploadPImgData.spuImages = item.imgvalue;
      this.uploadPImgData.spuId = "majorImageUrl";
      //$t('product.打开')
      this.openUploadProductImages = Symbol();
      $("#modalUploadProductImages").modal("show");
    },
    savePro() {
      let imgFlag = false;
      let params = {};
      this.styleTemplate.forEach((e) => {
        params[e.key] = e.templateValue;
        if (e.key == "propertyImage") {
          if (e.imgvalue.length) {
            params[e.key] = e.imgvalue;
          } else {
            imgFlag = true;
          }
        }
      });
      params.sku = this.itemSku;
      if (!params.name) {
        ShowTip(this.$t("product.请填写商品名称"), "danger");
        return;
      }
      if (!params.sku) {
        ShowTip(this.$t("product.请填写商品SKU编号"), "danger");
        return;
      }
      if (imgFlag) {
        ShowTip(this.$t("product.请上传至少一张图片"), "danger");
        return;
      }
      let urls = this.$route.query.id
        ? "api.SupplierStockSPU.changeNewStocks"
        : "api.SupplierStockSPU.addNewStocks";
      this.loading = true;
      $.api_call(urls, params, (r) => {
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("product.保存商品信息成功"), "success");
          setTimeout(() => {
            this.loading = false;
            this.$router.push({ path: "/oem-new-products" });
          }, 1000);
        } else {
          this.loading = false;
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getData() {
      this.loading = true;
      $.api_call("api.SupplierStockSPU.getTemplate", {}, (r) => {
        this.loading = false;
        if (r.ErrorCode == "9999") {
          this.styleTemplate = r.Data.Results;

          if (this.$route.query.id) {
            let item = {};
            $.api_call(
              "api.SupplierStockSPU.findNewStocks",
              { id: this.$route.query.id },
              (r) => {
                if (r.ErrorCode == "9999") {
                  if (r.Data.Results.length == 0) return;
                  item = r.Data.Results[0];
                  this.itemSku = item.sku;
                  this.styleTemplate.forEach((e) => {
                    this.$set(e, "templateValue", item[e.key]);
                    this.$set(e, "value", item[e.key]);
                    if (e.type == "img") {
                      this.$set(e, "imgvalue", []);
                    }
                    if (e.key == "propertyImage" && item.propertyImage) {
                      e.imgvalue = item.propertyImage;
                    }
                    if (e.key.indexOf("itemSpecific.") != -1) {
                      this.$set(
                        e,
                        "templateValue",
                        item.itemSpecific[e.key.split(".")[1]]
                      );
                    }
                  });
                }
              }
            );
          } else {
            this.styleTemplate.forEach((e) => {
              this.$set(e, "templateValue", "");
              this.$set(e, "value", "");
              if (e.type == "checkbox") {
                this.$set(e, "templateValue", []);
              }
              if (e.key == "propertyImage") {
                this.$set(e, "imgvalue", []);
              }
            });
          }
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
};
</script>
<style scoped="scoped">
.list-body:nth-child(2n) {
  background: #e9ecef;
  align-items: center;
  padding: 5px;
  margin-bottom: 2px;
}
.list-body:nth-child(2n + 1) {
  background: #f6f6f6;
  align-items: center;
  padding: 5px;
  margin-bottom: 2px;
}
.card,
.card .bootstrap-tagsinput {
  background: #fff;
}
.card .bootstrap-tagsinput {
  border-color: rgba(0, 0, 0, 0.15);
}
.tabs li a {
  color: #343a40;
}
.card {
  background-color: #fff;
  border-radius: 3px;
  padding: 30px;
  box-shadow: none;
  border: 1px solid #ddd;
}
.showCate .tabs li a.active {
  position: relative;
  top: 1px;
  z-index: 1;
  border: 1px #ddd solid;
  border-bottom-color: #fff;
  color: #148ea1;
  background-color: #fff;
}
.card {
  background-color: #fff;
  -webkit-box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.21);
  border-radius: 3px;
  padding: 15px 30px 0 !important;
}
.autocomplete-wrap ul {
  position: relative;
  max-height: 330px;
  overflow-y: scroll;
  z-index: 0;
}
.autocomplete-wrap li {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.autocomplete-wrap li a {
  width: 100%;
  height: 20px;
  line-height: 20px;
}
.autocomplete-wrap li a.close-a {
  min-width: 20px;
  min-height: 20px;
  width: 20px;

  text-align: center;
  color: #dc3545;
  padding: 0;
}
.autocomplete-wrap li a.close-a:hover {
  background: #dc3545;
  color: #fff;
}
.autocomplete-wrap li.active {
  background: #0866c6;
}
.autocomplete-wrap li.active a {
  color: #fff;
}
.autocomplete-wrap li.active a.close-a {
  color: #dc3545;
}
.autocomplete-wrap li.active a.close-a:hover {
  background: #dc3545;
  color: #fff;
}
.mode-card {
  min-height: 350px;
  max-height: 350px;
  overflow-y: scroll;
}
.clear-key {
  flex-wrap: wrap;
}
.clear-key a {
  margin-bottom: 10px;
  border: 1px rgba(0, 0, 0, 0.2) solid;
}
.clear-key a span {
  color: #333;
}
.overflow {
  overflow-x: scroll !important;
}
label.wd-100 {
  width: 120px;
}
</style>